import React, { Fragment } from 'react'
import { ComponentExt } from 'util/reactExt'
import { Icon, Button, Card, Pagination, Modal } from 'antd'
import { RouteComponentProps } from 'react-router'
import * as _ from 'lodash'

import VPlayer from 'components/VPlayer'
import Menus from '../components/Menus'
import Cate from '../../../../../../components/layout/CateLayout'

import styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {}

const types: any = [
  {
    key: '1000101',
    value: 'video',
  },
  {
    key: '1000102',
    value: 'article',
  },
  {
    key: '1000103',
    value: 'audio',
  },
  {
    key: '1000106',
    value: 'video',
  },
]

const CreateModal = props => {
  return (
    <Modal
      width={1000}
      visible={props.visible}
      footer={null}
      destroyOnClose
      onCancel={props.handleVisible}
    >
      <img width="100%" src={props.currentUrl} alt="" />
    </Modal>
  )
}

class Travel extends ComponentExt<IProps, IState> {
  state = {
    year: [],
    tagIndex: 0,
    vdData: {},
    imgData: [],
    imgTotal: 0,
    visible: false,
    visibleVP: false,
    currentUrl: '',
    currentYear: '',
  }

  vPlayerRef = null

  async componentDidMount() {
    this.handleFetchTravelYear()
  }

  async handleFetchTravelYear() {
    try {
      const year = await this.api.family.getFamilyTravelYear()
      this.setState({ year, currentYear: year[0] }, () => {
        this.handleFetchTravelDetail(year[0])
        this.handleFetchTravelPhotos(year[0])
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleFetchTravelDetail = async the_year => {
    try {
      const vdData = await this.api.family.getFamilyTravelDetail({ the_year })
      this.setState({ vdData })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleFetchTravelPhotos = async (the_year, page = 1) => {
    try {
      const {
        data: imgData,
        total: imgTotal,
      } = await this.api.family.getFamilyTravelPhotos({ the_year, page })
      this.setState({ imgData, imgTotal })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleImgVisible = currentUrl => {
    this.setState({
      visible: !this.state.visible,
      currentUrl,
    })
  }

  handleVisible = () => {
    this.setState({
      visible: false,
    })
  }

  handleTabChange = (_, val) => {
    const { year } = this.state

    this.setState(
      {
        tagIndex: val,
        visibleVP: false,
        visible: false,
        currentYear: year[val],
      },
      () => {
        this.handleFetchTravelDetail(year[val])
        this.handleFetchTravelPhotos(year[val])
      },
    )
  }

  handleToggleVPlayer = () => {
    const { visibleVP } = this.state
    if (!visibleVP) {
      // 开始播放
      this.vPlayerRef.player.play()
    } else {
      // 暂停播放
      this.vPlayerRef.player.pause()
    }
    this.setState({
      visibleVP: !visibleVP,
    })
  }

  handleLinkToArticle = ({ id, type }) => {
    if (!id || !type) {
      return false
    }
    window.open(`#/course/${id}?type=${type}`, '_blank')
  }

  handleRenderVideoAlbum = () => {
    const { vdData, visibleVP }: { vdData: any; visibleVP: any } = this.state
    const mapStyle = {
      LfBoxStyle: {
        backgroundImage: `url(${vdData.cover_img})`,
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
      },
      fixedTabStyle: {
        display: !visibleVP ? 'none' : 'block',
      },
    }
    return (
      <Fragment>
        <div className={styles.vdBanner}>
          <div
            className={
              !visibleVP
                ? styles.container
                : `${styles.container} ${styles.lfBoxAnimate}`
            }
            style={mapStyle.LfBoxStyle}
          >
            <div
              className={
                !visibleVP
                  ? styles.vdRightBox
                  : `${styles.vdRightBox} ${styles.rgBoxAnimate}`
              }
            >
              <div className={styles.title}>
                <span className={styles.time}>{vdData.date}</span>
                <span
                  className={styles.icon}
                  onClick={() =>
                    this.handleLinkToArticle({
                      id: vdData.article_id,
                      type: vdData.article_type,
                    })
                  }
                >
                  <Icon type="hdd" />
                </span>
              </div>
              <div className={styles.content}>
                <div className={styles.text}>
                  <p>{vdData.title}</p>
                  <Button
                    type="primary"
                    icon="play-circle"
                    onClick={this.handleToggleVPlayer}
                  >
                    立即播放
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            visibleVP
              ? `${styles.vplayer} ${styles.vPlayerAnimate}`
              : styles.vplayer
          }
        >
          <div className={styles.vpTags} style={mapStyle.fixedTabStyle}>
            <Icon
              type="close-circle"
              theme="filled"
              onClick={this.handleToggleVPlayer}
            />
            <Icon
              type="hdd"
              onClick={() =>
                this.handleLinkToArticle({
                  id: vdData.article_id,
                  type: vdData.article_type,
                })
              }
            />
          </div>
          <VPlayer
            ref={el => (this.vPlayerRef = el)}
            type={
              vdData.article_type
                ? types.filter(v => v.key === vdData.article_type)[0].value
                : 'video'
            }
            src={vdData.video_url}
            onplay={() => console.log('---play')}
          />
        </div>
      </Fragment>
    )
  }

  handleRenderImgAlbum = () => {
    const { imgData, tagIndex } = this.state
    return imgData.map((itm: any, idx) => {
      return (
        <Card.Grid
          key={idx}
          style={{
            width: '25%',
            textAlign: 'center',
          }}
        >
          <img
            onClick={() => this.handleImgVisible(itm)}
            src={itm}
            width="250"
            height="140"
          />
        </Card.Grid>
      )
    })
  }

  render() {
    const {
      handleRenderImgAlbum,
      handleRenderVideoAlbum,
      handleVisible,
      handleFetchTravelPhotos,
    } = this
    const {
      tagIndex,
      year,
      vdData,
      imgData,
      imgTotal,
      visible,
      currentUrl,
      currentYear,
    } = this.state
    const gridStyle = {
      width: '25%',
      textAlign: 'center',
    }
    const mapModalProps = {
      visible,
      currentUrl,
      handleVisible,
    }
    return (
      <div className={styles.travel}>
        <div className={styles.menu}>
          <Menus defaultKey="travel" />
        </div>
        <div className={styles.container}>
          <Cate
            title=""
            leftTabs={year}
            index={tagIndex}
            tabChange={this.handleTabChange}
            // loading={isLoading}
            notitle
          >
            <div className={styles.vdContainer}>
              {!_.isEmpty(vdData) && handleRenderVideoAlbum()}
            </div>
            <Card
              className={styles.imgContainer}
              title="精美图库"
              bordered={false}
              style={{ width: 1200 }}
            >
              {imgData && imgData.length > 0 && handleRenderImgAlbum()}
            </Card>
            <div style={{ width: '1200px' }}>
              <Pagination
                onChange={(p, s) => handleFetchTravelPhotos(currentYear, p)}
                defaultCurrent={1}
                pageSize={12}
                total={imgTotal}
              />
            </div>
          </Cate>
        </div>
        <CreateModal {...mapModalProps} />
      </div>
    )
  }
}

export default Travel
